import React from 'react';
import { Tooltip as MaterialTooltip } from 'material-ui';
import InfoIcon from 'material-ui-icons/Info';

export default class Tooltip extends React.Component{

	handleTooltipClose = (e) => {
		if(this.preventClose){
			return 0;
		}
		this.app.tooltip.open = null;
		this.forceUpdate();
	};

	handleTooltipOpen = () => {
		this.app.tooltip.open = this.id;
		this.preventClose = false;
		this.forceUpdate();
	}

	handleMouseLeave = () => {
		this.app.tooltip.open = null;
		this.forceUpdate();
	}

	preventNextClose = () => {
		this.preventClose = true;
		this.forceUpdate();
	}

	get app(){
		window.app.tooltip = window.app.tooltip || {open:false};
		return window.app;
	}

	get id(){
		return this.props.id;
	}

	render(){
		let size = this.props.size || '14px';
		let title = <div style={{width:this.props.width || '500px' }} onMouseLeave={this.handleMouseLeave} onMouseEnter={this.preventNextClose}>{this.props.children}</div>

		return (
		<MaterialTooltip 
			title={title}
			classes = {{root:'tooltip-root', tooltip:'custom-tooltip'}}
			leaveDelay={300}
			enterDelay={100}
			onClose={this.handleTooltipClose}
			onOpen={this.handleTooltipOpen}
			open={this.app.tooltip.open === this.id || window.tooltip === true}>
			<InfoIcon className={`custom-tooltip-anchor ${this.app.tooltip.open ? 'open': ''}`} style={{width:size, height:size, position:'relative', left:this.props.left, top:this.props.top}} />
		</MaterialTooltip>
	)}
}


// WEBPACK FOOTER //
// ./src/components/Tooltip.js